<template>
  <!--&lt;!&ndash;suppress JSUnresolvedVariable &ndash;&gt;-->
  <!--<a class="-button" :href="href" :download="download" @click="emitClick($event)">-->
    <!--<i :class="[iconClass, 'margin-right-4']"></i>{{value}}-->
  <!--</a>-->
  <el-button class="-button" :loading="loading" @click="handleDownload">
    <i :class="iconClass" class="margin-right-4" ></i>{{value}}
  </el-button>
</template>

<script>
import { downloadFile } from "../../../utils/browser";
import { loge } from "../../../utils/errorHandler";
import { nError, nSuccess } from "../../../utils/notice";

export default {
  name: "button-export",
  props: {
    value: {
      type: String,
      default: "导出"
    },
    iconClass: {
      type: String,
      default: "el-icon-damai-daochu"
    },
    href: String,
    download: {
      type: String,
      default: "报表.xls"
    },

    beforeDownload: {
      type: Function,
      default() {
        return Promise.resolve();
      }
    },
    getDownloadUrl: {
      type: Function
    }
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    handleDownload() {
      this._beforeDownload()
        .then(() => {
          setTimeout(() => {
            this._download();
          }, 100);
        })
        .catch(loge);
    },
    _beforeDownload() {
      return this.beforeDownload() || Promise.resolve();
    },
    _download() {
      // this.loading = true
      console.log(this.href);
      const { getDownloadUrl, href, download } = this;
      if (!getDownloadUrl && !href) {
        nError("该下载有问题");
        return;
      }
      const url = href;
      if (!url) {
        return;
      }
      Promise.resolve(url).then(url => {
        if (url) {
          setImmediate(() => {
            nSuccess("已开始下载，若导出数据过多请耐心等待");
            downloadFile(download, url);
          });
        } else {
          setImmediate(() => {
            nSuccess("暂无下载内容");
          });
        }
      });
      // setTimeout(() => {
      //   this.loading = false
      // }, 1000)
    }
  }
};
</script>

<style scoped lang="less">
@import "../styles/fun_var";

.-button {
  min-width: 80px;
  padding: 5px 16px;
  .generate-common-button(#f7f7f7);
}

.-button:hover {
  cursor: pointer;
  color: #1362ff;
  background-color: #f7f7f7;
  border: 1px solid #1362ff;
}
i{
  transform: translateY(-1.5px);
}
</style>

<style lang="less">
.-button {
  height: 32px;
  span {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 20px;
    line-height: 32px;
    transform: translateY(1.5px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/buttons/button-export.vue